import { createSelector } from 'reselect'
import { createSelector as ormCreateSelector } from 'redux-orm'
import orm from '../../models/models'

export const featuredProducts = createSelector(
  state => state.orm,
  ormCreateSelector(orm, session => {
    return session.FeaturedProduct.all().toModelArray()
  })
)
